<div class="onboarding-root">
  <div class="header">
    <app-epson-logo v2></app-epson-logo>
  </div>
  <div class="body">
    <app-loading *ngIf="showLoading" @fadeLoading (@fade.done)="loading = false"></app-loading>
    <div *ngIf="!loading" @fade class="details">
      <app-header>{{onboardingLabels.onboarding}}</app-header>
      <div class="welcome-text">
          {{onboardingLabels.onboardingDetail}}<br>
          <strong>{{onboardingLabels.onboardingDetail2}}</strong>
      </div>
      <app-admin-edit-data  [adminDataFormGroup]="onboardingFormGroup" ></app-admin-edit-data>
       <div class="select" *ngIf="role !== rolesReference.GLOBAL_ADMIN">
        <app-label isBig>{{onboardingLabels.accountRegion}}</app-label>
        <span>{{onboardingLabels.selectARegion}}</span>
         <app-select [options]="regions"
         [optionAccessor]="regionName"
         [control]="regionFormControl"
         [placeholder]="onboardingLabels.selectRegion"
         class="select"
         v2></app-select>
       </div>
      <app-icon-button v2 icon="arrow_forward" [disabled]="onboardingFormGroup.invalid" (clickAction)="saveAccountChanges()">{{onboardingLabels.next}}</app-icon-button>
    </div>
    <div class="loading" *ngIf="loadingSave" @fade>
      <mat-spinner [diameter]="100" class="spinner"></mat-spinner>
    </div>
</div>
